import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Enable',
				id: 'toggle',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return (
						hasPermission({
							entity: DASHBOARD_RESOURCES.userSegment,
							action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateFeatureSegments,
							appName,
							configPageName: PAGE_NAMES.dashboard
						}) && !rowData.enabled
					);
				}
			},
			{
				name: 'Disable',
				id: 'toggle',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return (
						hasPermission({
							entity: DASHBOARD_RESOURCES.userSegment,
							action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateFeatureSegments,
							appName,
							configPageName: PAGE_NAMES.dashboard
						}) && rowData.enabled
					);
				}
			},
			{
				name: 'Delete',
				id: 'delete',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateFeatureSegments,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.userSegment,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].createFeatureSegment,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};
